/**
 * Shared constants for the guide-core package.
 */

// Anchor positioning for the Khanmigo sidebar opener.
export const ANCHOR_BOTTOM = 80;
export const ANCHOR_RIGHT = 20;

// The designed icon size.  We size the bounding box to match.
export const ANCHOR_ICON_SIZE = 56;

export const HEADER_HEIGHT = 56;
export const INITIAL_WIDTH = 400;

/**
 * We show this message once to users to inform them who can
 * see their conversations and give context to how to use it.
 */
export const GUIDE_ACKNOWLEDGEMENT_PROMO_NAME = "ai-terms_accepted";

export const GUIDE_EXTENSION_BASE_PATH = "/guide-extension";
